import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './separator.scss';

export const HorizontalSeparator = ({ className, inverted }) =>
  <div className={classNames(styles.horizontal, className, getClassName(inverted))}/>;

HorizontalSeparator.propTypes = {
  className: PropTypes.string,
  inverted: PropTypes.bool,
};

export const VerticalSeparator = ({ className, inverted }) =>
  <div className={classNames(styles.vertical, className, getClassName(inverted))}/>;

VerticalSeparator.propTypes = {
  className: PropTypes.string,
  inverted: PropTypes.bool,
};

export const BulletSeparator = ({ className, inverted }) => (
  <div className={classNames(styles.bullet, className, getClassName(inverted))}/>
);

BulletSeparator.propTypes = {
  className: PropTypes.string,
  inverted: PropTypes.bool,
};

function getClassName(inverted) {
  return inverted ? 'forum-inverted-separator-background-color' : 'forum-separator-background-color';
}



// WEBPACK FOOTER //
// ./app/components/separator/separator.js